<template>
    <div class="bg-white rounded min-h-screen shadow">

        <RowColumn>
            <SearchCollapse :is-bg-white="true" class="mb-sm-0 mt-4 mr-3">
                <div class="grid grid-cols-10 gap-3 p-0 ml-3">
                    <div class="col-span-10 md:col-span-3 mt-0.5 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-8 ml-2">
                            {{ $t('company.name') }}
                        </div>
                        <b-form-input
                            v-model="search.customerCompanyName"
                            class="mr-md-1 outline-none focus:ring-0 border-gray-300"
                            @keyup.enter="searchFilters"
                        >
                        </b-form-input>
                    </div>

                    <div class="col-span-10 md:col-span-3 mt-0.5 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-8 ml-2">
                            {{ $t('person.givenName') }}
                        </div>
                        <b-form-input
                            v-model="search.personGivenName"
                            class="mr-md-1 outline-none focus:ring-0 border-gray-300"
                            @keyup.enter="searchFilters"
                        >
                        </b-form-input>
                    </div>

                    <div class="col-span-10 md:col-span-3 mt-0.5 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-8 ml-2">
                            {{ $t('person.familyName') }}
                        </div>
                        <b-form-input
                            v-model="search.personFamilyName"
                            class="mr-md-1 outline-none focus:ring-0 border-gray-300"
                            @keyup.enter="searchFilters"
                        >
                        </b-form-input>
                    </div>


                    <div class="col-span-10 md:col-span-1">
                        <button class="bg-main border-0 hover:bg-hoverMain rounded-l h-9 mt-0.5 w-50 focus:outline-none">
                            <img src="/images/search1.png" alt="" class="h-6 cursor-pointer" @click="searchFilters">
                        </button>
                        <button class="bg-main border-0 hover:bg-hoverMain rounded-r h-9 mt-0.5 w-50 focus:outline-none">
                            <img src="/images/eraser%20(2).png" alt="" class="h-6 cursor-pointer" @click="resetProductPurchaseSearchInfo">
                        </button>
                    </div>
                </div>
            </SearchCollapse>
        </RowColumn>

        <div class="row">
            <div class='col'>
                <table class="w-full mt-3">
                    <thead class="bg-lightGray h-12">
                    <tr class="font-bold">
                        <th class="d-none d-md-table-cell px-3">{{ $t('id') }}</th>
                        <th class="">{{ $t('customer.title') }}</th>
                        <th class="d-none d-md-table-cell">{{ $t('sale.product.title') }}</th>
                        <th class="d-none d-md-table-cell">{{ $t('sale.sum') }}</th>
                        <th class="">{{ $t('date') }}</th>
                        <th class="">{{ $t('actions') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item) in getDraftSales"
                        :key="item.id"
                        :class="item.isCanceled === true ? 'bg-red-100 h-12 border-bottom' : 'h-12 border-bottom'"
                    >
                        <td class="d-none d-md-table-cell px-3">{{ item.id }}</td>
                        <td>
                            <span class="text-main underline font-bold" @click="$i18nHelper.toUrl('customers/' + item.customer.id)">
                            {{ item.customer.person === null ? item.customer.customerCompany.name : item.customer.person.givenName + ' ' + item.customer.person.familyName }}
                            </span>
                        </td>
                        <td class="d-none d-md-table-cell">{{ item.saleProducts.length }} dona</td>
                        <td class="d-none d-md-table-cell">{{ showCurrencyById(item.currency.id, item.totalPrice) }}</td>
                        <td>
                            <div>{{ dateTimeFormat(item.createdAt) }}</div>
                            <div v-if="item.saleDraftUpdatedAts.length !== 0">
                                <div
                                    v-for="saleDraftUpdatedAt in item.saleDraftUpdatedAts"
                                    :key="saleDraftUpdatedAt.id"
                                    style="color: #5897fb"
                                >
                                    {{ dateTimeFormat(saleDraftUpdatedAt.updatedAt) }}
                                </div>
                            </div>

                        </td>
                        <td class="d-table-cell">
                            <img src="/images/edit.png"  v-if="!item.isCanceled" alt="" class="h-6 cursor-pointer" @click="setDetails(item)">
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div v-if="getDraftSales && getDraftSales.length === 0" class="col-12">{{ $t('noData') }}</div>
                <!-- ProductsList component -->
            </div>
        </div>

        <div class="row mt-4 ml-2">
            <div class="col">
                <PaginationRow
                    :search="search"
                    base-url="sales/drafts"
                    :total-items="getDraftSalesTotalCount ? getDraftSalesTotalCount : 0"
                    method-name="searchDraftSales"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import accessMixin from "../../mixin/accessMixin";
import currencyFormatMixin from "../../mixin/currencyFormatMixin";
import dateFormatting from "@/mixin/dateFormattingMixin";
import SearchCollapse from "@/components/SearchCollapse";
import RowColumn from "@/components/RowColumn";
import PaginationRow from "@/components/PaginationRow";

export default {
    name: "DraftSale",
    components: {
        PaginationRow,
        RowColumn,
        SearchCollapse,
    },
    mixins: [currencyFormatMixin, dateFormatting, accessMixin],
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'sale.title', url: 'sales/sale'},
                {name: 'sale.draft'},
            ],
            search: {
                customerCompanyName: '',
                personGivenName: '',
                personFamilyName: '',
                page: 1
            },
        }
    },
    computed: mapGetters(['getDraftSales', 'getDraftSalesTotalCount']),
    methods: {
        ...mapActions(['fetchDraftSales', 'pushDraftSale', 'searchDraftSales', 'setBreadcrumbItems']),
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        checkTransaction(item) {
            if (item.isCancelled) {
                return this.$t('sale.transaction.canceled');
            }

            return this.isPayed(item) ? this.$t('yes') : this.$t('no')
        },
        setDetails(item) {
            this.$i18nHelper.toUrl('sales/edit/' + item.id)
        },
        searchFilters() {
            this.$root.showOverlay = true
            this.searchDraftSales(this.search)
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.$root.showOverlay = false
                });
        },
        resetProductPurchaseSearchInfo() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.searchFilters()
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.fetchDraftSales()
    }
}
</script>

<style scoped>

</style>
